import { constructUrl } from '../pages/dataInputs/suppliers/constructUrl';

const TOKEN = localStorage.getItem('token');

export const uploadFile = async (recordUuid: string, file: File) => {
  const formData = new FormData();
  formData.append('files', file);

  const response = await fetch(constructUrl(`supplier/upload/${recordUuid}`), {
    method: 'POST',
    body: formData,
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  });

  if (!response.ok) {
    throw new Error('Failed to upload file');
  }

  const responseData = await response.json();
  if (responseData[0].httpStatusCode === 200) return true;
};

export const deleteFile = async (recordUuid: string, fileName: string) => {
  await fetch(constructUrl(`supplier/${recordUuid}/${fileName}`), {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  });
};

export const fetchFiles = async (recordUuid: string) => {
  const response = await fetch(constructUrl(`supplier/folder/${recordUuid}`), {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  });

  if (!response.ok) {
    throw new Error('Failed to fetch files');
  }

  return await response.json();
};
